<template>
    <v-modal ref="modal" @opened="modalOpened" >
        <slot slot="title">{{ $t('coupon.label.edit_value') }}</slot>
        <slot slot="buttonContent">
            <button type="button" class="c-button c-button--tiny c-button--alpha">
                <svgicon name="search" class="svg-icon svg-fill"></svgicon>
            </button>
        </slot>
        <div class="o-wrapper o-wrapper--center">
            <form action="" class="c-form c-form--horizontal">
                <div class="u-max-700 c-form-row">
                    <v-form-row>
                        <v-input v-model="currencyCode" name="currencyCode" :fluid="true" :disabled="true">
                            <slot slot="label">{{ $t('coupon.label.currency') }}</slot>
                        </v-input>
                    </v-form-row>
                    <v-form-row>
                        <v-input v-model="Amount" name="amount" type="number" :fluid="true">
                            <slot slot="label">{{ $t('coupon.label.amount') }}</slot>
                        </v-input>
                    </v-form-row>
                    <v-form-row>
                        <div class="c-form-item c-form-item--horizontal">
                            <v-label></v-label>
                            <button @click="editCouponValue" type="button" class="c-button c-button--alpha">{{ $t('coupon.button.edit') }}</button>
                        </div>
                    </v-form-row>
                </div>
            </form>
        </div>       
    </v-modal>
</template>

<script>
    import VModal from '@/components/modal/Modal'
    import VFormRow from '@/components/form/Row'
    import VInput from '@/components/form/Input'
    import VLabel from '@/components/form/Label'

    // Store
    import {mapGetters} from 'vuex'

    export default {
        components: {
            VModal,
            VFormRow,
            VInput,
            VLabel
        },
        data() {
            return {
                Amount: 0
            }
        },
        props: {
            couponValue: Object,
            currencyCode: String
        },
        methods: {
            editCouponValue() {
                this.couponValue.Value = this.Amount;
                this.$refs.modal.closeDialog();        
            },
            modalOpened() {
                this.Amount = this.couponValue.Value;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";
</style>


// WEBPACK FOOTER //
// src/components/coupons/EditCouponValue.vue